// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const changePasswordInCurrentPasswordMax = 256;

export const changePasswordInNewPasswordMax = 256;

export const ChangePasswordIn = zod.object({
  "current_password": zod.string().min(1).max(changePasswordInCurrentPasswordMax),
  "new_password": zod.string().min(1).max(changePasswordInNewPasswordMax)
});

export type ChangePasswordIn = zod.input<typeof ChangePasswordIn>;
export type ChangePasswordInOutput = zod.output<typeof ChangePasswordIn>;
